export interface KvkInformationType {
  organisationNumber: string;
  name: string;
  zipCode: string;
  town: string;
  street: string;
  streetNumber: string;
  houseNumberAddition: string;
  headquarters: boolean;
  status: string;
  active: boolean;
  subfileNumber: string;
  businessNumber: string;
  type: KvkInformationTypeType;
}

export type KvkInformationTypeType = 'HEADQUARTERS' | 'LEGAL_ENTITY' | 'BRANCH_OFFICE' | 'UNKNOWN';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isKvkInformationType = (obj: any): obj is KvkInformationType => {
  const isString = (value: unknown): boolean => typeof value === 'string';

  return obj && isString(obj.organisationNumber) && isString(obj.name) && isString(obj.type);
};
